import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { getCurrentYear } from "utils/helpers/getCurrentYear";
import PrivacyPolicy from "assets/pdf/accumulus_privacy_policy.pdf";
import styles from "./LegalFooter.styles";

const LegalFooter = () => {
  const { t } = useTranslation("common");

  return (
    <Box sx={styles.container} role="contentinfo">
      <Typography component="span" variant="body2">
        {t("footnoteCreatedBy", { currentYear: getCurrentYear() })}
      </Typography>
      <Box component="span">
        <Link to={PrivacyPolicy} rel="noreferrer" target="_blank">
          <Typography variant="body2">{t("privacyPolicy")}</Typography>
        </Link>
      </Box>
    </Box>
  );
};

export default LegalFooter;
